import { useTeamMembersQuery } from '@/hooks/queries/use-team-members-query';
import { Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

/** The teammate a brand message names in `metadata.authorUserId`, by first name. */
export function messageAuthorUserId(metadata: Record<string, unknown> | null | undefined): string | null {
  const value = metadata?.authorUserId;
  return typeof value === 'string' && value.length > 0 ? value : null;
}

/**
 * "Sent by Camille" under a brand message, when the teammate who wrote it is
 * still on the team. Says nothing otherwise: an older message names no one.
 */
export function MessageAuthorLine({ authorUserId }: { authorUserId: string }) {
  const { t } = useTranslation();
  const { data: members } = useTeamMembersQuery();
  const firstName = members?.find((member) => member.userId === authorUserId)?.firstName?.trim();
  if (!firstName) return null;
  return (
    <Text fontSize="xs" color="gray.500" mt={1}>
      {t('messages.sentBy', { firstName })}
    </Text>
  );
}
